<template>
  <div>
    <div
      :class="{card: true, 'mb-2': true, invalid: ui.valid === false}"
      v-if="hasDescriptions"
    >
      <div class="card-header px-2 py-2 d-flex justify-content-between align-items-center">
        <h5 class="d-flex align-items-center mb-0">
          <button
            class="btn btn-link text-muted font-weight-bold p-0 header-btn"
            @click="toggle('showDescription')"
          >
            Description
          </button>
          <button
            type="button"
            class="btn btn-link btn-sm"
            @click="removeAllRules"
            :disabled="$props.disabled || !$props.value.every(r => r.language === selectedLanguage && r.scope === 'property')"
          >
            Delete {{ langNameToCode[selectedLanguage] }} Rules
          </button>
        </h5>
        <div class="d-inline-flex">
          <select
            class="form-control form-control-sm w-auto mr-2"
            v-model="selectedLanguage"
            :disabled="$props.disabled"
          >
            <template v-for="language in propertyLanguages">
              <option
                :value="language.code"
                :key="language.code"
              >
                {{ language.name }}
                <template v-if="$props.value.some(r => r.language === language.code)">
                  ({{ $props.value.filter(r => r.language === language.code).length }})
                </template>
              </option>
            </template>
          </select>
          <div class="dropdown">
            <button
              class="btn btn-primary btn-sm dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              :disabled="$props.disabled"
            >
              Rules
            </button>
            <div
              class="dropdown-menu"
              aria-labelledby="dropdownMenuButton"
            >
              <button
                class="dropdown-item"
                type="button"
                @click="openDescRules(RuleKeyDescriptionRemoveText)"
                :disabled="overrideRule || $props.disabled"
              >
                {{ ruleLabels[RuleKeyDescriptionRemoveText] }}
              </button>
              <button
                class="dropdown-item"
                type="button"
                @click="openDescRules(RuleKeyDescriptionRemoveRange)"
                :disabled="overrideRule || $props.disabled"
              >
                {{ ruleLabels[RuleKeyDescriptionRemoveRange] }}
              </button>
              <button
                class="dropdown-item"
                type="button"
                @click="openDescRules(RuleKeyDescriptionRemoveIfContains)"
                :disabled="isSingleParagraph || overrideRule || $props.disabled"
              >
                {{ ruleLabels[RuleKeyDescriptionRemoveIfContains] }}
              </button>
              <button
                class="dropdown-item"
                type="button"
                @click="addCapitalisationRule"
                :disabled="capitalisationRule || $props.disabled"
              >
                {{ ruleLabels[RuleKeyDescriptionCapitalisation] }}
              </button>
              <div
                role="separator"
                class="dropdown-divider"
              />
              <button
                class="dropdown-item"
                type="button"
                @click="openDescRules(RuleKeyDescriptionOverride)"
                :disabled="$props.value.some(r => r.language === selectedLanguage)"
              >
                {{ ruleLabels[RuleKeyDescriptionOverride] }}
                <template v-if="$props.value.some(r => r.language === selectedLanguage)">
                  <small class="d-block">Remove other rules to apply this.</small>
                </template>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="ui.show"
        class="card-body px-2 py-2"
      >
        <div
          v-if="error.show"
          v-html="error.msg"
          class="alert alert-warning px-2"
        />
        <div
          v-if="ui.descRulesOpen"
          class="form-row mb-2"
        >
          <div class="col">
            <template v-if="ui.descRulesType === RuleKeyDescriptionRemoveText">
              <div class="form-group">
                <label class="text-truncate d-block small mb-0">{{ ruleLabels[RuleKeyDescriptionRemoveText] }}</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="the text to remove..."
                    v-model="ruleValues[RuleKeyDescriptionRemoveText].textToMatch"
                  >
                  <div class="input-group-append">
                    <button
                      class="btn btn-outline-primary"
                      type="button"
                      @click="addRemoveRule"
                    >
                      Add Rule
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="cancelEdit"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    v-model="ruleValues[RuleKeyDescriptionRemoveText].allLangauges"
                  >
                  <label class="form-check-label small">Apply to all languages?</label>
                </div>
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    v-model="ruleValues[RuleKeyDescriptionRemoveText].login"
                  >
                  <label class="form-check-label small">Apply to all properties from {{ $props.property.Login }}?</label>
                </div>
              </div>
            </template>
            <template v-if="ui.descRulesType === RuleKeyDescriptionRemoveIfContains">
              <div class="form-group">
                <label class="text-truncate d-block small mb-0">{{ ruleLabels[RuleKeyDescriptionRemoveIfContains] }}</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="The text within the paragraph..."
                    v-model="ruleValues[RuleKeyDescriptionRemoveIfContains].textToMatch"
                  >
                  <div class="input-group-append">
                    <button
                      class="btn btn-outline-primary"
                      type="button"
                      @click="addContainsRule"
                    >
                      Add Rule
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="cancelEdit"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    v-model="ruleValues[RuleKeyDescriptionRemoveIfContains].allLangauges"
                  >
                  <label class="form-check-label small">Apply to all languages?</label>
                </div>
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    v-model="ruleValues[RuleKeyDescriptionRemoveIfContains].login"
                  >
                  <label class="form-check-label small">Apply to all properties from {{ $props.property.Login }}?</label>
                </div>
              </div>
            </template>
            <template v-if="ui.descRulesType === RuleKeyDescriptionRemoveRange">
              <div class="form-group">
                <label class="text-truncate d-block small mb-0">{{ ruleLabels[RuleKeyDescriptionRemoveRange] }}</label>
                <div class="input-group mb-1">
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text"
                    >Start</span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Beginning text..."
                    v-model="ruleValues[RuleKeyDescriptionRemoveRange].start"
                  >
                </div>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text"
                    >End</span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="...end of text..."
                    v-model="ruleValues[RuleKeyDescriptionRemoveRange].end"
                  >
                  <div class="input-group-append">
                    <button
                      class="btn btn-outline-primary"
                      type="button"
                      @click="addRangeRule"
                    >
                      Add Rule
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="cancelEdit"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    v-model="ruleValues[RuleKeyDescriptionRemoveRange].allLangauges"
                  >
                  <label class="form-check-label small">Apply to all languages?</label>
                </div>
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    v-model="ruleValues[RuleKeyDescriptionRemoveRange].login"
                  >
                  <label class="form-check-label small">Apply to all properties from {{ $props.property.Login }}?</label>
                </div>
              </div>
            </template>
            <template v-if="ui.descRulesType === RuleKeyDescriptionOverride">
              <label class="text-truncate d-block small mb-0">{{ ruleLabels[RuleKeyDescriptionOverride] }}</label>
              <textarea
                id="desc"
                v-model="ruleValues[RuleKeyDescriptionOverride].text"
                class="form-control mb-2"
                :style="`height:${ui.descHeight};`"
              />
              <button
                type="button"
                class="btn btn-primary"
                @click="addOverrideRule"
              >
                Add Rule
              </button>
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click="cancelEdit"
              >
                Cancel
              </button>
            </template>
          </div>
        </div>
        <div class="form-row">
          <div class="col">
            <div
              v-if="isSingleParagraph && !overrideRule"
              class="alert alert-info font-weight-bold px-2 py-1 mb-1"
            >
              <i class="jam jam-alert-f" /> Some options are disabled as the description is formatted as a single paragraph.
            </div>
            <div
              v-if="containsHTML"
              class="alert alert-warning font-weight-bold px-2 py-1 mb-1"
            >
              <i class="jam jam-alert-f" /> This description looks to contain HTML. Please inform support as this should have been removed.
            </div>
            <div
              v-if="containsEmail"
              class="alert alert-warning font-weight-bold px-2 py-1 mb-1"
            >
              <i class="jam jam-alert-f" /> It looks like there might be a email address in this description.
            </div>
            <div
              v-if="containsURL"
              class="alert alert-warning font-weight-bold px-2 py-1 mb-1"
            >
              <i class="jam jam-alert-f" /> It looks like there might be a URL in this description.
            </div>
            <div
              v-if="containsTelephone"
              class="alert alert-warning font-weight-bold px-2 py-1 mb-1"
            >
              <i class="jam jam-alert-f" /> It looks like there might be a telephone number in this description.
            </div>
            <div
              id="description"
              class="card card-body bg-light p-1"
              title="You cannot edit the description directly."
              v-text="description"
            />
            <small class="text-muted">Note that the description above is displayed with all rules applied.</small>
            <template v-if="rules.length > 0">
              <hr>
              <div class="mt-3">
                <h5 class="d-inline-block font-weight-bold">
                  Rules
                </h5>
                <span class="d-inline-block small">({{ disabledRules.filter(r => r.language === selectedLanguage).length }} disabled)</span>
              </div>
              <div
                v-for="(rule, index) in rules"
                :key="index"
                :class="{
                  rule: true,
                  ruleDisabled: isDisabled(rule)
                }"
              >
                <p class="m-0">
                  <span><u>{{ ruleLabels[rule.key] }}</u></span>
                  <button
                    type="button"
                    class="btn btn-sm btn-link"
                    @click="removeRule(rule)"
                  >
                    Delete
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-link"
                    @click="editRule(rule)"
                    v-if="rule.key !== RuleKeyDescriptionCapitalisation"
                  >
                    Edit
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-link neverDisabled"
                    @click="toggleRule(rule)"
                  >
                    <template v-if="isDisabled(rule)">
                      Enable
                    </template>
                    <template v-else>
                      Disable
                    </template>
                  </button>
                </p>
                <ul class="list-unstyled pl-2">
                  <template v-if="rule.text">
                    <li class="d-flex">
                      <span class="text-muted font-weight-bold mr-1">{{ keyLabels['text'] }}:</span>
                      <span class="text-muted text-truncate">{{ rule[ 'text' ] }}</span>
                    </li>
                  </template>
                  <template v-else-if="rule.textToMatch">
                    <li class="d-flex">
                      <span class="text-muted font-weight-bold mr-1">{{ keyLabels['textToMatch'] }}:</span>
                      <span class="text-muted text-truncate">{{ rule[ 'textToMatch' ] }}</span>
                    </li>
                  </template>
                  <template v-else-if="rule.rangeStart && rule.rangeEnd">
                    <li class="d-flex">
                      <span class="text-muted font-weight-bold mr-1">{{ keyLabels['rangeStart'] }}:</span>
                      <span class="text-muted text-truncate">{{ rule[ 'rangeStart' ] }}</span>
                    </li>
                    <li class="d-flex">
                      <span class="text-muted font-weight-bold mr-1">{{ keyLabels['rangeEnd'] }}:</span>
                      <span class="text-muted text-truncate">{{ rule[ 'rangeEnd' ] }}</span>
                    </li>
                  </template>
                  <li class="d-flex">
                    <span class="text-muted font-weight-bold mr-1">{{ keyLabels['scope'] }}:</span>
                    <span class="text-muted text-truncate">{{ rule[ 'scope' ] }}</span>
                  </li>
                  <li class="d-flex">
                    <span class="text-muted font-weight-bold mr-1">{{ keyLabels['createdBy'] }}:</span>
                    <span class="text-muted text-truncate">{{ rule[ 'createdBy' ] }}</span>
                  </li>
                </ul>
                <hr v-if="index !== $props.value.length - 1">
              </div>
              <small class="text-muted">Enabling/disabling rules only takes affect while reviewing.<br>To remove a rule you must use the Delete option.</small>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
    availableLanguages,
    langNameToCode
} from '../common';

import {
    makeDescriptionRule,
    RuleKeyDescriptionRemoveText,
    RuleKeyDescriptionRemoveRange,
    RuleKeyDescriptionRemoveIfContains,
    RuleKeyDescriptionOverride,
    RuleKeyDescriptionCapitalisation,
    applyDescriptionRule
} from '../rules/description';

import {
    RuleScopeProperty,
    RuleScopeLogin
} from '../consts';

const languagePreferenceOrder = [ 'es', 'en', 'de', 'fr', 'da', 'nl', 'fi', 'it', 'no', 'pl', 'pt', 'sv' ];

export default {
    data: () => ( {
        selectedLanguage: 'es',
        ui: {
            valid: true,
            show: true,
            descRulesOpen: false,
            descRulesType: '',
            descHeight: 'auto',
            descriptions: {}
        },
        error: {
            show: false,
            msg: ''
        },
        ruleValues: {
            [ RuleKeyDescriptionRemoveText ]: {
                textToMatch: '',
                login: false,
                allLangauges: false
            },
            [ RuleKeyDescriptionRemoveRange ]: {
                start: '',
                end: '',
                login: false,
                allLangauges: false
            },
            [ RuleKeyDescriptionRemoveIfContains ]: {
                textToMatch: '',
                login: false,
                allLangauges: false
            },
            [ RuleKeyDescriptionOverride ]: {
                text: ''
            }
        },
        disabledRules: [],
        editCopy: null
    } ),
    computed: {
        containsHTML() {
            return /<.*>|<.*\/>/gi.test( this.$props.property.Description[ langNameToCode[ this.selectedLanguage ] ] );
        },
        containsURL() {
            return /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test( this.description );
        },
        containsEmail() {
            return /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/.test( this.description );
        },
        containsTelephone() {
            return /\+[\s0-9-]{9,}/.test( this.description );
        },
        description() {
            let description = this.$props.property.Description[ langNameToCode[ this.selectedLanguage ] ];

            if ( this.rules.length === 0 ) {
                return description;
            }

            if ( this.removeRules.length > 0 ) {
                this.removeRules.forEach( rule => {
                    const disabled = this.disabledRules.find( r => r.key === RuleKeyDescriptionRemoveText && r.language === this.selectedLanguage && r.textToMatch === rule.textToMatch );
                    if ( disabled ) {
                        return;
                    }

                    description = applyDescriptionRule( description, rule );
                } );
            }

            if ( this.containRules.length > 0 ) {
                this.containRules.forEach( rule => {
                    const disabled = this.disabledRules.find( r => r.key === RuleKeyDescriptionRemoveIfContains && r.language === this.selectedLanguage && r.textToMatch === rule.textToMatch );

                    if ( disabled ) {
                        return;
                    }

                    description = applyDescriptionRule( description, rule );
                } );
            }

            if ( this.rangeRules.length > 0 ) {
                this.rangeRules.forEach( rule => {
                    const disabled = this.disabledRules.find( r => r.key === RuleKeyDescriptionRemoveRange && r.language === this.selectedLanguage && r.rangeStart === rule.rangeStart && r.rangeEnd === rule.rangeEnd );
                    if ( disabled ) {
                        return;
                    }

                    description = applyDescriptionRule( description, rule );
                } );
            }

            if ( this.capitalisationRule ) {
                const disabled = this.disabledRules.find( r => r.key === RuleKeyDescriptionCapitalisation && r.language === this.selectedLanguage );

                if ( !disabled ) {
                    description = applyDescriptionRule( description, this.capitalisationRule );
                }
            }

            if ( this.overrideRule ) {
                const disabled = this.disabledRules.find( r => r.key === RuleKeyDescriptionOverride && r.language === this.selectedLanguage );
                if ( !disabled ) {
                    description = applyDescriptionRule( description, this.overrideRule );
                }
            }

            description = description.replaceAll( /\n{3,}/g, '\n\n' );

            description = description.replaceAll( /^\n/g, '' );

            description = description.replaceAll( /\n$/g, '' );

            description = description.trim();

            return description;
        },
        hasDescriptions() {
            return this.$props.property && Object.keys( this.$props.property.Description ).some( lang => this.$props.property.Description[ lang ].length > 0 );
        },
        propertyLanguages() {
            return availableLanguages.filter( language => {
                const langName = langNameToCode[ language.code ];
                if ( !this.$props.property.Description[ langName ] ) {
                    return false;
                }
                if ( this.$props.property.Description[ langName ].length === 0 ) {
                    return false;
                }
                return true;
            } );
        },
        isSingleParagraph() {
            return !this.description.includes( '\n' ) && !this.description.includes( '<br>' );
        },
        rules() {
            return this.$props.value.filter( rule => rule.language === this.selectedLanguage );
        },
        removeRules() {
            return this.rules.filter( rule => rule.key === RuleKeyDescriptionRemoveText );
        },
        containRules() {
            return this.rules.filter( rule => rule.key === RuleKeyDescriptionRemoveIfContains );
        },
        rangeRules() {
            return this.rules.filter( rule => rule.key === RuleKeyDescriptionRemoveRange );
        },
        overrideRule() {
            return this.rules.find( rule => rule.key === RuleKeyDescriptionOverride );
        },
        capitalisationRule() {
            return this.rules.find( rule => rule.key === RuleKeyDescriptionCapitalisation );
        }
    },
    methods: {
        openDescRules( ruleType ) {
            this.ui.descRulesOpen = true;
            this.ui.descRulesType = ruleType;

            if ( ruleType === RuleKeyDescriptionRemoveText ) {
                let formatted = document.getElementById( 'description' );
                this.ui.descHeight = `${formatted.getBoundingClientRect().height}px`;
                this.ruleValues[ RuleKeyDescriptionRemoveText ].text = this.description;
            }
        },
        reset() {
            this.ui = this.initialState;
            this.disabledRules = [];
        },
        resetDesc() {
            this.error.show = false;
            this.ui.descRulesOpen = false;
            this.ui.descRulesType = '';
            this.ui.descHeight = 'auto';
            this.editCopy = null;

            this.ruleValues[ RuleKeyDescriptionRemoveText ].textToMatch = '';
            this.ruleValues[ RuleKeyDescriptionRemoveText ].login = false;
            this.ruleValues[ RuleKeyDescriptionRemoveText ].allLangauges = false;

            this.ruleValues[ RuleKeyDescriptionRemoveRange ].start = '';
            this.ruleValues[ RuleKeyDescriptionRemoveRange ].end = '';
            this.ruleValues[ RuleKeyDescriptionRemoveRange ].login = false;
            this.ruleValues[ RuleKeyDescriptionRemoveRange ].allLangauges = false;

            this.ruleValues[ RuleKeyDescriptionRemoveIfContains ].textToMatch = '';
            this.ruleValues[ RuleKeyDescriptionRemoveIfContains ].login = false;
            this.ruleValues[ RuleKeyDescriptionRemoveIfContains ].allLangauges = false;

            this.ruleValues[ RuleKeyDescriptionOverride ].text = '';
        },
        isDisabled( rule ) {
            if ( rule.key === RuleKeyDescriptionOverride || rule.key === RuleKeyDescriptionCapitalisation ) {
                return this.disabledRules.some( r => r.key === rule.key && rule.language === r.language );
            } else if ( 'text' in rule ) {
                return this.disabledRules.some( r => r.key === rule.key && rule.language === r.language && r.text === rule.text );
            } else if ( 'textToMatch' in rule ) {
                return this.disabledRules.some( r => r.key === rule.key && rule.language === r.language && r.textToMatch === rule.textToMatch );
            } else if ( 'rangeStart' in rule && 'rangeEnd' in rule ) {
                return this.disabledRules.some( r => r.key === rule.key && rule.language === r.language && r.rangeStart === rule.rangeStart && r.rangeEnd === rule.rangeEnd );
            }
        },
        validate() {
            let state = {
                valid: true,
                msg: ''
            };

            this.ui.valid = state.valid;

            if ( this.disabledRules.length > 0 ) {
                state.valid = false;
                state.msg = `${this.disabledRules.length} description rules have been disabled. Enable or Delete them to continue.`;

                this.selectedLanguage = this.disabledRules[ 0 ].language;
            }

            if ( this.editCopy !== null ) {
                state.valid = false;
                state.msg = 'Please Add/Cancel editing the description rule currently open for editing.';

                this.selectedLanguage = this.editCopy.language;
            }

            this.ui.valid = state.valid;

            setTimeout( () => {
                this.ui.valid = true;
            }, 3000 );

            return state;
        },
        removeAllRules() {
            if ( this.disabledRules.length > 0 ) {
                this.disabledRules = this.disabledRules.filter( rule => rule.language !== this.selectedLanguage );
            }
            this.$emit( 'input', this.$props.value.filter( rule => rule.language !== this.selectedLanguage ) );
        },
        addRemoveRule() {
            this.error.show = false;
            const textToRemove = this.ruleValues[ RuleKeyDescriptionRemoveText ].textToMatch;

            let ruleTemplate = {
                language: this.selectedLanguage,
                createdBy: this.$store.getters.email,
                textToMatch: textToRemove,
                scope: RuleScopeProperty
            };

            if ( this.ruleValues[ RuleKeyDescriptionRemoveText ].login ) {
                const login = this.$props.property.Login;

                const continueAdd = confirm( `Are you sure you want to add that rule? All properties from ${login} will be affected.` );

                if ( !continueAdd ) {
                    return;
                }

                ruleTemplate.scope = RuleScopeLogin;
                ruleTemplate.login = login;
            }

            let templates = [ ruleTemplate ];

            if ( this.ruleValues[ RuleKeyDescriptionRemoveText ].allLangauges ) {
                availableLanguages.filter( language => language.code !== this.selectedLanguage ).forEach( language => {
                    const templateInLanguage = Object.assign( {}, ruleTemplate );
                    templateInLanguage.language = language.code;
                    templates.push( templateInLanguage );
                } );
            }

            let rulesToAdd = [];

            for ( let i = 0; i < templates.length; i++ ) {
                const result = makeDescriptionRule( templates[ i ], RuleKeyDescriptionRemoveText );

                if ( result.error !== null ) {
                    this.error.msg = result.error.toString();
                    this.error.show = true;
                    return;
                }

                const duplicate = this.$props.value.some( rule => rule.language === result.rule.language && rule.textToMatch === result.rule.textToMatch && rule.key === RuleKeyDescriptionRemoveText );

                if ( duplicate ) {
                    this.error.msg = `A ${langNameToCode[ result.rule.language ]} rule already exists for text "${result.rule.textToMatch}"`;
                    this.error.show = true;
                    return;
                }

                rulesToAdd.push( result.rule );
            }

            if ( rulesToAdd.length === 0 ) {
                return;
            }

            let rules = this.$props.value;
            rules = [].concat( rules, rulesToAdd );

            this.$emit( 'input', rules );
            this.resetDesc();
        },
        addContainsRule() {
            this.error.show = false;
            const textToMatch = this.ruleValues[ RuleKeyDescriptionRemoveIfContains ].textToMatch;

            let ruleTemplate = {
                language: this.selectedLanguage,
                createdBy: this.$store.getters.email,
                textToMatch: textToMatch,
                scope: RuleScopeProperty
            };

            if ( this.ruleValues[ RuleKeyDescriptionRemoveIfContains ].login ) {
                const login = this.$props.property.Login;

                const continueAdd = confirm( `Are you sure you want to add that rule? All properties from ${login} will be affected.` );

                if ( !continueAdd ) {
                    return;
                }

                ruleTemplate.scope = RuleScopeLogin;
                ruleTemplate.login = login;
            }

            let templates = [ ruleTemplate ];

            if ( this.ruleValues[ RuleKeyDescriptionRemoveIfContains ].allLangauges ) {
                availableLanguages.filter( language => language.code !== this.selectedLanguage ).forEach( language => {
                    const templateInLanguage = Object.assign( {}, ruleTemplate );
                    templateInLanguage.language = language.code;
                    templates.push( templateInLanguage );
                } );
            }

            let rulesToAdd = [];

            for ( let i = 0; i < templates.length; i++ ) {
                const result = makeDescriptionRule( templates[ i ], RuleKeyDescriptionRemoveIfContains );

                if ( result.error !== null ) {
                    this.error.show = true;
                    this.error.msg = result.error.toString();
                    return;
                }

                const duplicate = this.$props.value.some( rule => rule.language === result.rule.language && rule.textToMatch === result.rule.textToMatch && rule.key === RuleKeyDescriptionRemoveIfContains );

                if ( duplicate ) {
                    this.error.msg = `A ${langNameToCode[ result.rule.language ]} rule already exists for text "${result.rule.textToMatch}"`;
                    this.error.show = true;
                    return;
                }

                rulesToAdd.push( result.rule );
            }

            if ( rulesToAdd.length === 0 ) {
                return;
            }

            let rules = this.$props.value;
            rules = [].concat( rules, rulesToAdd );

            this.$emit( 'input', rules );
            this.resetDesc();
        },
        addRangeRule() {
            this.error.show = false;

            const start = this.ruleValues[ RuleKeyDescriptionRemoveRange ].start;
            const end = this.ruleValues[ RuleKeyDescriptionRemoveRange ].end;

            let ruleTemplate = {
                language: this.selectedLanguage,
                createdBy: this.$store.getters.email,
                rangeStart: start,
                rangeEnd: end,
                scope: RuleScopeProperty
            };

            if ( this.ruleValues[ RuleKeyDescriptionRemoveRange ].login ) {
                const login = this.$props.property.Login;

                const continueAdd = confirm( `Are you sure you want to add that rule? All properties from ${login} will be affected.` );

                if ( !continueAdd ) {
                    return;
                }

                ruleTemplate.scope = RuleScopeLogin;
                ruleTemplate.login = login;
            }

            let templates = [ ruleTemplate ];

            if ( this.ruleValues[ RuleKeyDescriptionRemoveRange ].allLangauges ) {
                availableLanguages.filter( language => language.code !== this.selectedLanguage ).forEach( language => {
                    const templateInLanguage = Object.assign( {}, ruleTemplate );
                    templateInLanguage.language = language.code;
                    templates.push( templateInLanguage );
                } );
            }

            let rulesToAdd = [];

            for ( let i = 0; i < templates.length; i++ ) {
                const result = makeDescriptionRule( templates[ i ], RuleKeyDescriptionRemoveRange );

                if ( result.error !== null ) {
                    this.error.show = true;
                    this.error.msg = result.error.toString();
                    return;
                }

                const duplicate = this.$props.value.some( rule => rule.language === result.rule.language && rule.rangeStart === result.rule.rangeStart && rule.rangeEnd === result.rule.rangeEnd && rule.key === RuleKeyDescriptionRemoveRange );

                if ( duplicate ) {
                    this.error.msg = `A ${langNameToCode[ result.rule.language ]} rule already exists for the range: "${result.rule.rangeStart}" & "${result.rule.rangeEnd}"`;
                    this.error.show = true;
                    return;
                }

                rulesToAdd.push( result.rule );
            }

            if ( rulesToAdd.length === 0 ) {
                return;
            }

            let rules = this.$props.value;
            rules = [].concat( rules, rulesToAdd );

            this.$emit( 'input', rules );
            this.resetDesc();
        },
        addOverrideRule() {
            this.error.show = false;
            const newDescription = this.ruleValues[ RuleKeyDescriptionOverride ].text;

            const result = makeDescriptionRule( {
                language: this.selectedLanguage,
                createdBy: this.$store.getters.email,
                text: newDescription,
                scope: RuleScopeProperty
            }, RuleKeyDescriptionOverride );

            if ( result.error !== null ) {
                this.error.show = true;
                this.error.msg = result.error.toString();
                return;
            }

            const rules = this.$props.value;
            rules.push( result.rule );
            this.$emit( 'input', rules );

            this.resetDesc();
        },
        addCapitalisationRule() {
            this.error.show = false;

            const result = makeDescriptionRule( {
                language: this.selectedLanguage,
                createdBy: this.$store.getters.email,
                scope: RuleScopeProperty
            }, RuleKeyDescriptionCapitalisation );

            if ( result.error !== null ) {
                this.error.show = true;
                this.error.msg = result.error.toString();
                return;
            }

            const rules = this.$props.value;
            rules.push( result.rule );
            this.$emit( 'input', rules );
        },
        cancelEdit() {
            if ( this.editCopy !== null ) {
                this.$emit( 'input', [].concat( this.$props.value, [ this.editCopy ] ) );
                this.editCopy = null;
            }

            this.resetDesc();
        },
        removeDisabled( ruleToRemove ) {
            if ( this.disabledRules.length === 0 ) {
                return;
            }

            let filtered = [];

            if ( ruleToRemove.key === RuleKeyDescriptionRemoveRange ) {
                for ( let i = 0; i < this.disabledRules.length; i++ ) {
                    let match = ( this.disabledRules[ i ].language === ruleToRemove.language && this.disabledRules[ i ].key === ruleToRemove.key && this.disabledRules[ i ].rangeStart === ruleToRemove.rangeStart && this.disabledRules[ i ].rangeEnd === ruleToRemove.rangeEnd );
                    if ( match ) {
                        continue;
                    }
                    filtered.push( this.disabledRules[ i ] );
                }
            }

            if ( ruleToRemove.key === RuleKeyDescriptionRemoveText ) {
                for ( let i = 0; i < this.disabledRules.length; i++ ) {
                    let match = ( this.disabledRules[ i ].language === ruleToRemove.language && this.disabledRules[ i ].key === ruleToRemove.key && this.disabledRules[ i ].textToMatch === ruleToRemove.textToMatch );
                    if ( match ) {
                        continue;
                    }
                    filtered.push( this.disabledRules[ i ] );
                }
            }

            if ( ruleToRemove.key === RuleKeyDescriptionRemoveIfContains ) {
                for ( let i = 0; i < this.disabledRules.length; i++ ) {
                    let match = ( this.disabledRules[ i ].language === ruleToRemove.language && this.disabledRules[ i ].key === ruleToRemove.key && this.disabledRules[ i ].textToMatch === ruleToRemove.textToMatch );
                    if ( match ) {
                        continue;
                    }
                    filtered.push( this.disabledRules[ i ] );
                }
            }

            if ( ruleToRemove.key === RuleKeyDescriptionOverride ) {
                filtered = this.disabledRules.filter( rule => {
                    if ( rule.language !== ruleToRemove.language && rule.key !== ruleToRemove.key ) {
                        return true;
                    }
                    return false;
                } );
            }

            this.disabledRules = filtered;
        },
        removeRule( ruleToRemove, skipConfirm = false ) {
            const rules = this.$props.value;

            if ( !skipConfirm && 'scope' in ruleToRemove && ruleToRemove.scope === RuleScopeLogin ) {
                const continueRemove = confirm( 'Are you sure you want to remove that rule?' );
                if ( continueRemove !== true ) {
                    return false;
                }
            }

            let filtered = [];

            if ( ruleToRemove.key === RuleKeyDescriptionRemoveRange ) {
                for ( let i = 0; i < rules.length; i++ ) {
                    let match = ( rules[ i ].language === ruleToRemove.language && rules[ i ].key === ruleToRemove.key && rules[ i ].rangeStart === ruleToRemove.rangeStart && rules[ i ].rangeEnd === ruleToRemove.rangeEnd );
                    if ( match ) {
                        continue;
                    }
                    filtered.push( rules[ i ] );
                }
            }

            if ( ruleToRemove.key === RuleKeyDescriptionRemoveText ) {
                for ( let i = 0; i < rules.length; i++ ) {
                    let match = ( rules[ i ].language === ruleToRemove.language && rules[ i ].key === ruleToRemove.key && rules[ i ].textToMatch === ruleToRemove.textToMatch );
                    if ( match ) {
                        continue;
                    }
                    filtered.push( rules[ i ] );
                }
            }

            if ( ruleToRemove.key === RuleKeyDescriptionRemoveIfContains ) {
                for ( let i = 0; i < rules.length; i++ ) {
                    let match = ( rules[ i ].language === ruleToRemove.language && rules[ i ].key === ruleToRemove.key && rules[ i ].textToMatch === ruleToRemove.textToMatch );
                    if ( match ) {
                        continue;
                    }
                    filtered.push( rules[ i ] );
                }
            }

            if ( ruleToRemove.key === RuleKeyDescriptionOverride ) {
                for ( let i = 0; i < rules.length; i++ ) {
                    let match = ( rules[ i ].language === ruleToRemove.language && rules[ i ].key === RuleKeyDescriptionOverride );
                    if ( match ) {
                        continue;
                    }
                    filtered.push( rules[ i ] );
                }
            }

            if ( ruleToRemove.key === RuleKeyDescriptionCapitalisation ) {
                for ( let i = 0; i < rules.length; i++ ) {
                    let match = ( rules[ i ].language === ruleToRemove.language && rules[ i ].key === RuleKeyDescriptionCapitalisation );
                    if ( match ) {
                        continue;
                    }
                    filtered.push( rules[ i ] );
                }
            }

            this.removeDisabled( ruleToRemove );

            this.$emit( 'input', filtered );
            return true;
        },
        editRule( rule ) {
            if ( rule.scope === RuleScopeLogin ) {
                const confirmEdit = confirm( 'Are you sure you want to edit the rule?' );
                if ( !confirmEdit ) {
                    return;
                }
            }

            switch ( rule.key ) {
            case RuleKeyDescriptionRemoveText:
                this.ruleValues[ RuleKeyDescriptionRemoveText ].textToMatch = rule.textToMatch;

                if ( 'scope' in rule && rule.scope === RuleScopeLogin ) {
                    this.ruleValues[ RuleKeyDescriptionRemoveText ].login = true;
                }

                this.ui.descRulesType = RuleKeyDescriptionRemoveText;

                break;
            case RuleKeyDescriptionRemoveRange:
                this.ruleValues[ RuleKeyDescriptionRemoveRange ].start = rule.rangeStart;
                this.ruleValues[ RuleKeyDescriptionRemoveRange ].end = rule.rangeEnd;

                if ( 'scope' in rule && rule.scope === RuleScopeLogin ) {
                    this.ruleValues[ RuleKeyDescriptionRemoveRange ].login = true;
                }

                this.ui.descRulesType = RuleKeyDescriptionRemoveRange;
                break;
            case RuleKeyDescriptionRemoveIfContains:
                this.ruleValues[ RuleKeyDescriptionRemoveIfContains ].textToMatch = rule.textToMatch;

                if ( 'scope' in rule && rule.scope === RuleScopeLogin ) {
                    this.ruleValues[ RuleKeyDescriptionRemoveIfContains ].login = true;
                }

                this.ui.descRulesType = RuleKeyDescriptionRemoveIfContains;
                break;
            case RuleKeyDescriptionOverride:
                this.ruleValues[ RuleKeyDescriptionOverride ].text = rule.text;
                this.ui.descRulesType = RuleKeyDescriptionOverride;
                break;
            default:
                return;
            }

            this.editCopy = rule;
            this.ui.descRulesOpen = true;

            this.removeRule( rule, true ); // with true passed this will always return true
        },
        toggleRule( rule ) {
            let isDisabled = false;

            switch ( rule.key ) {
            case RuleKeyDescriptionRemoveText:
                isDisabled = this.disabledRules.find( r => {
                    if ( r.key === rule.key &&
                         r.language === rule.language &&
                         r.textToMatch === rule.textToMatch
                    ) {
                        return rule;
                    }
                } );

                if ( isDisabled ) {
                    this.disabledRules = this.disabledRules.filter( r => {
                        if ( r.key === rule.key &&
                         r.language === rule.language &&
                         r.textToMatch === rule.textToMatch
                        ) {
                            return false;
                        }
                        return true;
                    } );
                } else {
                    let newRules = this.disabledRules;
                    newRules.push( rule );
                    this.disabledRules = newRules;
                }

                break;
            case RuleKeyDescriptionRemoveRange:
                isDisabled = this.disabledRules.find( r => {
                    if ( r.key === rule.key &&
                         r.language === rule.language &&
                         r.rangeStart === rule.rangeStart &&
                         r.rangeEnd === rule.rangeEnd
                    ) {
                        return rule;
                    }
                } );

                if ( isDisabled ) {
                    this.disabledRules = this.disabledRules.filter( r => {
                        if ( r.key === rule.key &&
                         r.language === rule.language &&
                         r.rangeStart === rule.rangeStart &&
                         r.rangeEnd === rule.rangeEnd
                        ) {
                            return false;
                        }
                        return true;
                    } );
                } else {
                    let newRules = this.disabledRules;
                    newRules.push( rule );
                    this.disabledRules = newRules;
                }
                break;
            case RuleKeyDescriptionRemoveIfContains:
                isDisabled = this.disabledRules.find( r => {
                    if ( r.key === rule.key &&
                         r.language === rule.language &&
                         r.textToMatch === rule.textToMatch
                    ) {
                        return rule;
                    }
                } );

                if ( isDisabled ) {
                    this.disabledRules = this.disabledRules.filter( r => {
                        if ( r.key === rule.key &&
                         r.language === rule.language &&
                         r.textToMatch === rule.textToMatch
                        ) {
                            return false;
                        }
                        return true;
                    } );
                } else {
                    let newRules = this.disabledRules;
                    newRules.push( rule );
                    this.disabledRules = newRules;
                }
                break;
            case RuleKeyDescriptionOverride:
                isDisabled = this.disabledRules.find( r => {
                    if ( r.key === rule.key &&
                         r.language === rule.language &&
                         r.text === rule.text
                    ) {
                        return rule;
                    }
                } );

                if ( isDisabled ) {
                    this.disabledRules = this.disabledRules.filter( r => {
                        if ( r.key === rule.key &&
                         r.language === rule.language &&
                         r.text === rule.text
                        ) {
                            return false;
                        }
                        return true;
                    } );
                } else {
                    let newRules = this.disabledRules;
                    newRules.push( rule );
                    this.disabledRules = newRules;
                }
                break;
            case RuleKeyDescriptionCapitalisation:
                isDisabled = this.disabledRules.find( r => {
                    if ( r.key === rule.key && r.language === rule.language ) {
                        return rule;
                    }
                } );

                if ( isDisabled ) {
                    this.disabledRules = this.disabledRules.filter( r => {
                        if ( r.key === rule.key && r.language === rule.language ) {
                            return false;
                        }
                        return true;
                    } );
                } else {
                    let newRules = this.disabledRules;
                    newRules.push( rule );
                    this.disabledRules = newRules;
                }
                break;
            }
        },
        setSelectedLanguage() {
            for ( let i = 0; i < languagePreferenceOrder.length; i++ ) {
                const language = languagePreferenceOrder[ i ];
                if ( this.propertyLanguages.find( l => l.code === language ) ) {
                    this.selectedLanguage = language;
                    break;
                }
            }
        }
    },
    created() {
        this.initialState = this.ui;
        this.langNameToCode = langNameToCode;

        this.RuleKeyDescriptionRemoveIfContains = RuleKeyDescriptionRemoveIfContains;
        this.RuleKeyDescriptionRemoveText = RuleKeyDescriptionRemoveText;
        this.RuleKeyDescriptionRemoveRange = RuleKeyDescriptionRemoveRange;
        this.RuleKeyDescriptionOverride = RuleKeyDescriptionOverride;
        this.RuleKeyDescriptionCapitalisation = RuleKeyDescriptionCapitalisation;

        this.ruleLabels = {
            [ RuleKeyDescriptionRemoveIfContains ]: 'Remove Paragraphs Containing',
            [ RuleKeyDescriptionRemoveText ]: 'Remove Specific Text',
            [ RuleKeyDescriptionRemoveRange ]: 'Remove All In-Range',
            [ RuleKeyDescriptionOverride ]: 'Manual Override',
            [ RuleKeyDescriptionCapitalisation ]: 'Remove Uppercase Blocks'
        };

        this.keyLabels = {
            createdBy: 'Created By',
            textToMatch: 'Text',
            text: 'Text',
            rangeStart: 'Start',
            rangeEnd: 'End',
            scope: 'Scope'
        };
    },
    watch: {
        property: {
            immediate: true,
            handler() {
                this.setSelectedLanguage();
            }
        }
    },
    props: {
        property: {
            required: false,
            type: Object,
            default: () => ( {
                Description: {}
            } )
        },
        value: {
            required: false,
            type: Array,
            default: () => []
        },
        disabled: {
            required: true,
            type: Boolean,
            default: () => false
        }
    }
};
</script>
<style scoped>
  #description {
    white-space: pre-line;
  }
  .rule {
    padding-left: 4px;
    border-left: 4px solid #c3e6cb;
  }
  .ruleDisabled {
    border-left: 4px solid #f5c6cb;
  }
</style>



// WEBPACK FOOTER //
// src/components/property-qc/handlers/DescriptionRuleHandler.vue